/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React, { FC } from 'react';
import { LandingPageTip } from './LandingPageTip';

import '../../scss/bootstrap.min.css';
import '../../scss/style.scss';

const getInTouchLink = 'mailto:team@mysterium.network';

export const LandingPage: FC = () => {
    return (
        <div>
            <header id="header" className="fixed-top">
                <div className="container d-flex align-items-center">
                    <h1 className="logo mr-auto">
                        <a href="index.html">
                            <img src="/assets/img/MysteriumLogo.svg" alt="Mysterium Network Logo" />
                        </a>
                    </h1>

                    <p className="white-text font-weight-bold">
                        Become an affiliate{' '}
                        <a href={getInTouchLink} className="top_button">
                            Get in touch
                        </a>
                    </p>
                </div>
            </header>

            <div className="container-fluid">
                <section id="hero" className="d-flex align-items-center">
                    <div
                        className="container position-relative"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12 left-block">
                                    <h1>Mysterium Affiliate Program </h1>
                                    <p>
                                        Make the internet a better place, and get paid for it.
                                        Crypto bonuses for your community, crypto rewards for you.
                                    </p>
                                    <div className="row">
                                        <div className="col-lg-5 col-md-12 col-sm-12">
                                            <p className="hint-text">To view your earnings</p>
                                            <a
                                                href="/#/dashboard"
                                                className="pink-button fixwidth-button"
                                            >
                                                Login
                                            </a>
                                            <LandingPageTip />
                                        </div>
                                        <div className="col-lg-7 col-md-12 col-sm-12">
                                            <p className="hint-text">
                                                Interested in becoming an affiliate?
                                            </p>
                                            <a
                                                href={getInTouchLink}
                                                className="pink-button fixwidth-button"
                                            >
                                                Get in touch
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 right-block">
                                    <img
                                        src="assets/img/affiliatemoney-bannergraphic.jpg"
                                        alt="Affiliate Money Banner"
                                        className="money_banner"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="container-fluid bg-pink">
                <main id="main">
                    <div className="container">
                        <div className="text-center about-vpn">
                            <h2 className="center-align ">Mysterium VPN</h2>
                            <p className="about-vpn">
                                {' '}
                                The Mysterium VPN is the world’s first pay-as-you-go VPN, powered by
                                crypto. <br />
                                No subscriptions, no bank cards, no email address.
                                <br />
                                Just switch it on and only pay for the minutes you actually use.{' '}
                            </p>
                        </div>
                        <div className="mobile-app">
                            <a
                                href="https://www.mysteriumvpn.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src="assets/img/mobilepreview.jpg"
                                    className="mobile-apppreview"
                                    alt="Mysterium Mobile App Preview"
                                />
                            </a>{' '}
                        </div>
                    </div>
                </main>
            </div>

            <div className="container-fluid bgcolor">
                <div className="container">
                    <h3 className="center-align ">How it works</h3>
                    <p className="center-align">
                        Introduce your users to the Mysterium universe, and you all receive rewards.{' '}
                    </p>
                    <div className="howitworks-graphic-holder">
                        {' '}
                        <img
                            src="assets/img/howitworks-graphic.jpg"
                            className="howitworks-graphic"
                            alt="Mysterium Mobile App Preview"
                        />{' '}
                    </div>
                    <div className="stepwizard">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-12 center-align cblock">
                                {' '}
                                <span className="step-pill">Step 1</span>{' '}
                                <img src="assets/img/getcode-icon.svg" alt="Get your code - icon" />
                                <h4>Get your code </h4>
                                <p>
                                    Our team generates your special affiliate code. The code is
                                    valid for one year, with an option to renew at the end.{' '}
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 center-align cblock">
                                {' '}
                                <span className="step-pill">Step 2</span>{' '}
                                <img
                                    src="assets/img/communityshare-icon.svg"
                                    alt="Share with your community - icon"
                                />
                                <h4>Share with your community </h4>
                                <p>
                                    Your users receive a 1 MYST bonus in their VPN account when they
                                    use your code to register. That’s equivalent to 10 Gigabytes of
                                    free streaming!{' '}
                                </p>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 center-align cblock">
                                {' '}
                                <span className="step-pill">Step 3</span>{' '}
                                <img
                                    src="assets/img/cryptocurrency-icon.svg"
                                    alt="Get crypto rewards - icon"
                                />
                                <h4>Get crypto rewards</h4>
                                <p>
                                    Affiliates receive 5% of everything their referred users spend
                                    on VPN services. For example, if your users spend 10K MYST, you
                                    will receive a 500 MYST payout. Users can pay with all major
                                    crypto, such as BTC, LTC, ETH or DAI.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="about-myst">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <h3>
                                    Payouts in MYST, <br />a cryptocurrency that fights internet
                                    censorship
                                </h3>
                                <p>
                                    All affiliate rewards will be paid in MYST, the network’s native
                                    cryptocurrency. You can learn more about{' '}
                                    <a
                                        href="https://mysterium.network/token/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        MYST here.
                                    </a>
                                </p>
                                <p>
                                    MYST tokens will be paid into your MetaMask wallet, the most
                                    trusted and widely used wallet for Ethereum-based tokens. You
                                    can login to the affiliate dashboard to track your rewards and
                                    withdraw earnings directly into your wallet. You can then trade,
                                    exchange, hodl or even stake your MYST tokens whenever you like.
                                    All rewards must be claimed within one year from affiliate code
                                    creation.
                                </p>
                                <p>Cash rewards coming soon. </p>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="token-graphic-holder">
                                    {' '}
                                    <img
                                        src="assets/img/Mysttoken-graphic-pink.jpg"
                                        className="token-graphic"
                                        alt="MYST-Token Graphic"
                                    />{' '}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="love-myst">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="love-graphic-holder">
                                    {' '}
                                    <img
                                        src="assets/img/love-mysterium-graphic.jpg"
                                        className="love-graphic"
                                        alt="Love & Share Mysterium"
                                    />{' '}
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <h3>
                                    Mysterium. Easy to love, <br />
                                    even easier to share.
                                </h3>
                                <p>
                                    Spread good digital karma with our branding kit and promo
                                    materials. <br />
                                    Add us to your blogs, website, app or just spread the Mysterium
                                    magic around on your community channels.{' '}
                                </p>
                                <br />
                                <p>
                                    {' '}
                                    <a
                                        href="https://mysterium.network/wp-content/uploads/2020/04/Mysterium-Network-Logo-Source-Files.zip"
                                        className="pink-button"
                                    >
                                        Download Branding Kit
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="netstats center-align">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <h3>Our Network Stats</h3>
                                <p>
                                    Mysterium is one of the fastest growing communities
                                    decentralising the web.{' '}
                                </p>
                                <div className="stats-wizard">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-12 center-align cblock">
                                            {' '}
                                            <img
                                                src="assets/img/activenodes-icon.svg"
                                                alt="Nodes
active all time - icon"
                                            />
                                            <h4>1253</h4>
                                            <p>
                                                Nodes <br />
                                                active all time{' '}
                                            </p>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12 center-align cblock">
                                            {' '}
                                            <img
                                                src="assets/img/trafficserved-icon.svg"
                                                alt="Traffic - icon"
                                            />
                                            <h4>317 Tb</h4>
                                            <p>
                                                Traffic <br />
                                                served till now{' '}
                                            </p>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12 center-align cblock">
                                            {' '}
                                            <img
                                                src="assets/img/countries-icon.svg"
                                                alt="Countries - icon"
                                            />
                                            <h4>80</h4>
                                            <p>
                                                Countries <br />
                                                across the globe
                                            </p>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12 center-align cblock">
                                            {' '}
                                            <img
                                                src="assets/img/activesessions-icon.svg"
                                                alt="Active sessions daily - icon"
                                            />
                                            <h4>27783</h4>
                                            <p>
                                                Active <br />
                                                sessions daily
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="earn-myst">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <h6 className="white-text">Earn while you sleep.</h6>
                                <h3>
                                    Affiliate program for node runners <br />
                                    <span className="yellow-text">[COMING SOON]</span>
                                </h3>
                                <p>
                                    Most of the internet you pay for goes to waste, sitting idle or
                                    completely unused. Our global network of node runners rent their
                                    spare bandwidth whenever it suits them, so they earn crypto even
                                    while they work or sleep.{' '}
                                </p>
                                <p>
                                    For every new node you onboard to Mysterium Network, you will
                                    receive a reward. So you can also sleep well at night, knowing
                                    you’re making the internet more accessible and secure.
                                </p>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="earn-graphic-holder">
                                    {' '}
                                    <img
                                        src="assets/img/noderunners-graphic.jpg"
                                        className="earn-graphic"
                                        alt="Earn MYST"
                                    />{' '}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <footer id="footer">
                    <div className="footer-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <h4>Interested in becoming an affiliate?</h4>
                                    <p>
                                        {' '}
                                        <a href={getInTouchLink} className="pink-button">
                                            Get in touch
                                        </a>
                                    </p>
                                    <div className="mystlogo-graphic-holder">
                                        {' '}
                                        <img
                                            src="assets/img/mystlogo-footer.svg"
                                            className="mystlogo-graphic"
                                            alt="Earn MYST"
                                        />{' '}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <p className="center-align copyright">
                                BlockDev AG, Seestrasse 5 CH-6300 Zug, Switzerland. Read our Website
                                Privacy Policy and Terms & Conditions.
                                <br />
                                Mysterium Network is developed by Blockdev AG.Discovery services
                                within Mysterium Network are run by NetSys Inc.
                                <br />© 2021 Mysterium Network.
                            </p>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
};
